import {
  USER_SIGN_IN_ERROR,
  USER_SIGN_IN_REQUEST,
  USER_SIGN_IN_SUCCESS,
  USER_LOG_OUT_ERROR,
  USER_LOG_OUT_REQUEST,
  USER_LOG_OUT_SUCCESS,
  MENU_CHANGED,
  SELECT_MANUFACTURER,
  SELECT_INSPECTOR,
  UPDATE_MANUFACTURER,
  USER_SAVE_URL,
  USER_CLEAR_URL,
  SELECT_YEAR,
} from '../actionTypes';

const initState = {
  token: null,
  redirect: null,
  firstName: '',
  lastName: '',
  roles: [],
  activeRole: null,
  selectedManufacturer: null,
  selectedInspector: null,
  manufacturer: {},
  email: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case USER_SIGN_IN_REQUEST:
      return state;
    case USER_SIGN_IN_SUCCESS:
      return { ...state, ...action.payload };
    case USER_SIGN_IN_ERROR:
      return { ...state, token: null };

    case USER_LOG_OUT_REQUEST:
      return state;
    case USER_LOG_OUT_SUCCESS:
      return { ...initState, redirect: initState.redirect };
    case USER_LOG_OUT_ERROR:
      return state;

    case USER_SAVE_URL:
      return { ...state, redirect: action.payload };
    case USER_CLEAR_URL:
      return { ...state, redirect: initState.redirect };

    case MENU_CHANGED:
      return {
        ...state,
        activeRole: action.payload,
        selectedManufacturer: initState.selectedManufacturer,
        selectedInspector: initState.selectedInspector,
      };

    case SELECT_MANUFACTURER:
      return { ...state, selectedManufacturer: action.payload };
    case SELECT_INSPECTOR:
      return { ...state, selectedInspector: action.payload, selectedManufacturer: null };
    case UPDATE_MANUFACTURER: {
      const selectedManufacturer = state.selectedManufacturer ? state.selectedManufacturer : {};
      return { ...state, selectedManufacturer: { ...selectedManufacturer, ...action.payload } };
    }
    case SELECT_YEAR:
      return { ...state, selectedYear: { ...state.selectedYear, [action.payload.role]: action.payload.year } };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/store/reducers/user.js